import React from "react";
import plutonicLogo from "../assets/images/plutonicLogo.svg";
import plutonicName from "../assets/images/plutonicName.svg";

const INTERNAL_TEST_URL =
  "https://play.google.com/apps/internaltest/4701645060515467153";

const AndroidDownloadPage = () => (
  <main className="flex min-h-screen items-center justify-center bg-gradient-to-b from-[#D8F8FF] via-white to-sky-50 px-5 py-10">
    <section className="w-full max-w-md rounded-3xl border border-sky-100 bg-white p-7 text-center shadow-2xl sm:p-10">
      <div className="mb-7 flex items-center justify-center gap-3">
        <img src={plutonicLogo} alt="" className="h-14 w-20 object-contain" />
        <img src={plutonicName} alt="Plutonic" className="h-9 w-36 object-contain" />
      </div>

      <p className="mb-2 text-sm font-bold uppercase tracking-[0.18em] text-[#1687bd]">
        Android internal test
      </p>
      <h1 className="text-3xl font-bold text-gray-900">
        Get Plutonic on Android
      </h1>
      <p className="mt-4 leading-relaxed text-gray-600">
        Plutonic is currently available to invited Android testers through
        Google Play. Open the testing page with the Google account that was
        invited, join the test, and install the app.
      </p>

      <a
        href={INTERNAL_TEST_URL}
        className="mt-8 inline-flex min-h-14 w-full items-center justify-center rounded-full bg-[#22AAEE] px-6 py-3 text-lg font-semibold text-white shadow-lg transition hover:bg-[#1687bd] focus:outline-none focus:ring-4 focus:ring-sky-200"
      >
        Get Plutonic on Google Play
      </a>

      <p className="mt-5 text-sm leading-relaxed text-gray-500">
        You must be signed into an approved tester account. Access may take a
        few minutes after you are added.
      </p>
    </section>
  </main>
);

export default AndroidDownloadPage;
